import { CUSTOM_TYPES } from "./custom-types";
import { SYSTEM_TYPES } from "./system-types";

export function getFieldTypeConfig(field) {
    const { fieldType, isSystem } = field;
    if (isSystem) return SYSTEM_TYPES[fieldType];
    return CUSTOM_TYPES[fieldType];
}
